<div class="card-body text-center">
  <a class="btn btn-primary btn-lg" (click)="downloadFile()">
    <i class="fa fa-download"></i> {{ '::DownloadFile' | abpLocalization }}
  </a>
</div>
